import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../../styles/fontawesome-styles.css'
import './theme-colors.css'
import './theme-variables.css'
import './theme-alerts.css'
import './theme-badges.css'
import './theme-buttons.css'
import './theme-cards.css'
import './theme-borders.css'
import './theme-navigation.css'
import './theme-backgrounds.css'
import './FontStyles.css'
import './ResearchBrandStyles.css'
import './layout.css'
import '../../../node_modules/react-bootstrap/dist/react-bootstrap.min.js'
import SideMenu from './SideMenu'


const Layout = ({ children}) => {
   const { header, footer, prismicContentHome, prismicFeaturedHome, allPrismicSubject } = useStaticQuery(graphql`
    {
        header {
			html
		}
        footer {
			html
		}        
            prismicContentHome{
                        uid
                        id
                        type
                        url
                        data {
                            page_title {
                                text
                            }
                        } 
            }
            prismicFeaturedHome{
                        uid
                        id
                        type
                        url
                        data {
                         page_title {
                             text
                            }
                        }   
            }
            allPrismicSubject(sort: {fields: data___subject_name, order: ASC}){
                edges{
                    node{   
                        uid
                        type
                        url
                        data {
                            subject_name
                            subject_icon
                        }    
                    }
                }
            }
        
    }
   `)

    return (
        <>
            <header id="header" dangerouslySetInnerHTML={{ __html: header.html }}></header>
            <main id="main-content" className="container-fluid">
                <Row className="mb-3">
                    <Col lg={2} id="sidebar" className="px-0">
                        <SideMenu featured={prismicFeaturedHome} all={prismicContentHome} subjects={allPrismicSubject.edges} />
                    </Col>
                    <Col lg={10} id="rightSide" className="mt-4">
                    {children}
                    </Col>
                </Row>
            </main>
            <footer id="footer" dangerouslySetInnerHTML={{ __html: footer.html }}></footer>
        </>
    )
}

export default Layout;